import React from "react";
export const ComponentHeader = ({ mainTitle, subTitle }) => (React.createElement("div", { className: "ComponentHeader" },
    React.createElement("h2", { className: "ComponentHeader__mainTitle" }, mainTitle),
    React.createElement("p", { className: "ComponentHeader__subTitle" }, subTitle)));
